import Testimonial from '@editor/components/Testimonial/CheckoutFlowTestimonial';
import TrialExplanation from '@editor/components/UpgradeFlowModal/TrialExplanation';
import { withEventScope } from '@repo/event-processor';
import { useTranslation } from '@repo/i18n';
import { SubscriptionPlanType } from '@repo/subscription/api';

import { RightColumnTrial, RightColumnTrialExplanation } from './styles';

type Props = {
  startDate: Date;
  plan: SubscriptionPlanType;
};

/**
 * TrialRightSection just shows a testimonial and roadmap UI
 *
 * @param startDate - The trial period start date
 * @param plan - The subscription plan type (SubscriptionPlanType)
 */
const TrialRightSection: React.FC<Props> = ({ startDate, plan }) => {
  const { t } = useTranslation();

  const testimonial = {
    name: t('subscriptionModal:testimonial.name', {
      context: plan.toLocaleLowerCase(),
    }),
    text: t('subscriptionModal:testimonial.text', {
      context: plan.toLocaleLowerCase(),
    }),
    image:
      plan === SubscriptionPlanType.EXPERT
        ? '/images/testimonialProfilePictureExpert.png'
        : '/images/testimonialProfilePicturePro.png',
  };

  return (
    <RightColumnTrial data-testid="subscriptionModal--trial-right-section">
      <RightColumnTrialExplanation>
        <TrialExplanation plan={plan} startDate={startDate} />
      </RightColumnTrialExplanation>
      <Testimonial {...testimonial} />
    </RightColumnTrial>
  );
};

export default withEventScope(TrialRightSection, {
  module: 'trialRightSection',
});
